import React from 'react';
import PropTypes from 'prop-types';
import Help from '../../common/Help';

const helpText = (t, helpKey) => {
  switch (true) {
    case /^input_footprint_housing_heatingoil/.test(helpKey): {
      return t('To calculate your total annual usage or cost of heating oil or other fuels to heat your home, review your monthly bills for heating oil or other home heating fuels. Each bill will tell you how many litres of oil were delivered to you each month at what cost.');
    }
    case /^input_footprint_housing_naturalgas/.test(helpKey): {
      return t('To calculate your total annual natural gas usage or costs, review your monthly utility bills. Each bill will tell you how many cubic metres you have used in the month at what cost.');
    }
    case /^input_footprint_housing_electricity/.test(helpKey): {
      return t('To calculate your total electricity usage or costs, review your monthly electricity bills.  Each bill will tell you how many kilowatt hours you have used in the month at what cost.');
    }
    case /^input_footprint_housing_squarefeet/.test(helpKey): {
      return t(
        '<strong>For a house</strong>, measure the length of a house and multiply it by the width of the house. If you have two stories, multiply by two. <strong>For an apartment or condo</strong>, first determine the area of each room by multiplying the length and width of each room. Add up the total area measurements for each room.  This will give you the total area of your living space, all rooms combined.',
      );
    }
    case /^home_page/.test(helpKey): {
      return t('If you don\'t have time or the right information available to calculate this value, you can skip the question and an average value for your location based on provincial data will be added for you.');
    }
    case /^goods/.test(helpKey): {
      return t('We recommend you leave the default values, which are calculated based on your household size and income. Alternatively, simply adjust total monthly spending based on your best guess estimate.');
    }
    default: {
      throw new Error(`Unrecognized helpKey for pages/home/Help.js ${helpKey}.`);
    }
  }
};

const HomeHelp = ({ t, helpKey, faIcon }) => (
  <Help
    popoverProps={{ id: `help_${helpKey}` }}
    helpText={helpText(t, helpKey)}
    faIcon={faIcon}
  />
);

HomeHelp.propTypes = {
  t: PropTypes.func.isRequired,
  helpKey: PropTypes.string.isRequired,
  faIcon: PropTypes.string,
};

HomeHelp.defaultProps = {
  faIcon: 'question-circle',
};

export default HomeHelp;
